
export const ROOT_ROUTE = "/";

// PUBLIC NOT LOGGED

// PUBLIC LOGGED
export const USER_HOME_ROUTE = "public-home";

// PRIVATE
export const PRIVATE_MAIN_ROUTE = "private-main";
export const NURSERIES_ROUTE = "nurseries-route";
export const SPHERES_ROUTE = "spheres-route";
export const MAP_ROUTE = "map-route";
export const BACKOFFICE_LOGIN_ROUTE = "backoffice-login";
export const FRONTOFFICE_LOGIN_ROUTE = "frontoffice-login";
export const PRIVATE_NURSERY_ROUTE = "private-nursery";
export const PRIVATE_NURSERY_LIST_ROUTE = "private-nursery-list";
export const PRIVATE_NURSERY_DETAIL_ROUTE = "private-nursery-detail";
export const PRIVATE_NURSERY_EDIT_ROUTE = "private-nursery-edit";
export const PRIVATE_NURSERY_SPHERE_ROUTE = "private-nursery-sphere";
export const PRIVATE_NURSERY_MAP_ROUTE = "private-nursery-map";
export const PRIVATE_NURSERY_ADD_ROUTE = "private-nursery-add";

export const PRIVATE_PROMOTION_ROUTE = "private-promotion";
export const PRIVATE_PROMOTION_EDIT_ROUTE = "private-promotion-edit";
export const PRIVATE_PROMOTION_ADD_ROUTE = "private-promotion-add";
export const PRIVATE_PROMOTION_LIST_ROUTE = "private-promotion-list";

export const PRIVATE_CHANGE_PASSWORD_ROUTE = "private-change-password";

export const PRIVATE_LOG_ROUTE = "private-log";

